import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class AcceptanceCriteriaFormBaseComponent {
  criteriaForm: FormGroup;
  errorMessage: string | null = null;

  constructor(protected fb: FormBuilder) {
    this.criteriaForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  markAllFieldsAsTouched(): void {
    Object.keys(this.criteriaForm.controls).forEach(field => {
      const control = this.criteriaForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get name() {
    return this.criteriaForm.get('name');
  }
  get description() {
    return this.criteriaForm.get('description');
  }
}
